import { useContext, useState } from "react";
import "./Footer.scss";
import Logo from "../assets/LOGO_FOOTER.png";
import { Link } from "react-router-dom";
import { Form, FormGroup, Image } from "react-bootstrap";
import { Envelope, ArrowUp } from "react-bootstrap-icons";
import dataWeb from "../assets/images/dataweb.jpg";
import logoDDS from "../assets/logo-dds-footer.svg";
import useValidation from "../services/useValidation";
import { addToNewletter } from "../services/NewsletterServices";
import { usePage } from "../services/PageContext";
import { AuthContext } from "../services/AuthContext";
import useInView from "../hooks/useInView";

export default function Footer() {
  const [validated, setValidated] = useState(false);
  const emailValidation = useValidation('','email');
  const [emailAdded, setEmailAdded] = useState(false);
  const { siderMenu } = usePage()
  const { isAuthenticated, user } = useContext(AuthContext);
  // rootMargin negativo en bottom: un pequeño margen para que no dispare
  // apenas asoma el borde, sin llegar a que el footer se vea vacío.
  const [footerRef, footerInView] = useInView({ threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

  const handleSubmit = (event) => {
    const form = event.currentTarget
    event.preventDefault()
    event.stopPropagation()
    if (form.checkValidity()) {
      addToNewsletter();
    }
    setValidated(true)
  }

  const addToNewsletter = () => {
    var f = new FormData();
    f.append("email", emailValidation.value);
    addToNewletter(f)
    .then(()=>{
      setEmailAdded(true)
    })
    .catch(err=>{console.log(err)})
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <>
      <footer className={siderMenu ? 'is-mobile' : ''}>
        <div className={`footer-wrapper ${footerInView ? 'in-view' : ''}`} ref={footerRef}>
          <div className="content">
            <div className="footer-top">
              <div className="footer-brand">
                <Link className="logo">
                  <Image src={Logo} />
                </Link>
              </div>
              <button type="button" className="scroll-top" onClick={scrollToTop} aria-label="Volver arriba">
                <ArrowUp />
              </button>
            </div>
            <div className="footer-content">
              <div className="module module-footer-desc">
                <h6>
                  Somos una distribuidora mayorista de librería y papelería
                  escolar y comercial ubicada en la ciudad de Bahía Blanca,
                  provincia de Buenos Aires.
                </h6>
                <div className="newsletter-wrapper">
                  <div className="newsletter-header">
                    <span className="icon">
                      <Envelope />
                    </span>
                    <h4>
                      Informate de nuestras últimas noticias y ofertas
                      especiales
                    </h4>
                  </div>
                  <div className="newsletter-form-wrapper">
                    {!emailAdded
                      ? <Form noValidate validated={validated} onSubmit={handleSubmit}  className="newsletter-form">
                          <FormGroup>
                            <Form.Control
                              type="email"
                              value={emailValidation.value}
                              onChange={emailValidation.handleChange}
                              isInvalid={!emailValidation.isValid}
                              required
                            />
                            <Form.Control.Feedback type="invalid">
                              {emailValidation.errorMessage != '' ? emailValidation.errorMessage : "Debe ingresar el e-mail"}
                            </Form.Control.Feedback>
                          </FormGroup>

                            <button type="submit">Suscribirse</button>
                        </Form>
                      : <h3>Gracias</h3>
                    }
                  </div>
                </div>
              </div>
              <div className="module module-footer module-footer-menu">
                <span className="label">Menú</span>
                <Link to={'/como-operar'}>Cómo operar</Link>
                <Link to={'/faqs'}>Preguntas Frecuentes</Link>
                <Link to={'/cbu'}>Datos bancarios</Link>
                <Link to={'/registro'}>Registrate</Link>
                <Link to={'/terminos-condiciones'}>Términos y Condiciones</Link>
                <div className="dds-mention">
                  <span className="label">JUGUETES · JUEGOS · LIBROS</span>
                  <a href="https://www.didacticosdelsur.com" target="_blank" rel="noopener noreferrer">
                    <Image src={logoDDS} alt="Didácticos del Sur" />
                  </a>
                </div>
              </div>
              <div className="module module-footer module-footer-contact">
                <div className="contact-block">
                  <span className="label">Dirección</span>
                  <p>
                    Zapiola 400, Bahía Blanca<br />
                    Buenos Aires, Argentina.
                  </p>
                </div>
                <div className="contact-block">
                  <span className="label">Tel. fijo</span>
                  <a href="tel:+542914563688">
                    291 - 4563688
                  </a>
                </div>
                {isAuthenticated && user?.vendedorTelefono &&
                  <div className="contact-block">
                    <span className="label">WhatsApp de {user.vendedorNombre}</span>
                    <a href={`https://wa.me/54${String(user.vendedorTelefono).replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer">
                      {user.vendedorTelefono}
                    </a>
                  </div>
                }
                <div className="contact-block">
                  <span className="label">E-mail</span>
                  <a href="mailto:contacto@libreriadelcolegio.com">
                    contacto@libreriadelcolegio.com
                  </a>
                </div>
                <div className="contact-block">
                  <span className="label">Horario de atención</span>
                  <p>Lun a Vie de 9 a 18 hs.</p>
                </div>
              </div>
            </div>

            <div className="copyright">
              <p>Todos los derechos reservados ®. 1982-{new Date().getFullYear()}</p>
              <p>
                <a
                  href="http://qr.afip.gob.ar/?qr=aNjSu-6x_oJPssWeerj_Eg,,"
                  target="_F960AFIPInfo"
                >
                  <Image src={dataWeb} />
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
